import React, { FC } from "react";
import { faCircleXmark } from "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CircleXmark: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faCircleXmark} {...props} />
);
